import React from 'react'

import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import './assets/sass/global.scss'
import { IS_DEVELOPMENT } from 'common/constants'

import App from './App'

if (IS_DEVELOPMENT) {
  import('./common/mocks/handlers')
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)
